import {
  Container,
  Col,
  Row,
  Button,
  ProgressBar,
  Modal,
  Form,
} from "react-bootstrap";
import { useState } from "react";
import AnalyticsModal from "./AnalyticsModal";

const AnalyticsTab = ({ analytic, questions, analytics, setAnalytics }) => {
  const [modalShow, setModalShow] = useState(false);

  const getEquation = () => {
    let res = `${analytic.analytic_name} = `;
    let vars = [];
    analytic.analytic_variables.forEach((v) => {
      if (v[0] === "-") {
        vars.push(`(${v})`);
        return;
      }
      vars.push(`${v}`);
    });
    res += `mean( ${vars.join(" + ")} )`;
    return res;
  };

  return (
    <Container fluid className="text-left">
      <Row>
        <Col xs={10}>{getEquation()}</Col>
        <Col xs={2}>
          <Button
            variant="outline-success mr-auto"
            onClick={() => setModalShow(true)}
          >
            Modify
          </Button>
        </Col>
      </Row>
      <AnalyticsModal
        show={modalShow}
        questions={questions}
        onHide={() => setModalShow(false)}
        analytic={analytic}
        newAnalytics={false}
        analytics={analytics}
        setAnalytics={setAnalytics}
      />
    </Container>
  );
};

export default AnalyticsTab;
